
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import isNil from 'lodash/isNil';
import { mergeStyleSets } from '@uifabric/merge-styles';

import { INPUT_TYPE_DRAW, INPUT_TYPE_FILE } from '../../reducers/project';

const classNames = mergeStyleSets({
    root: {
        height: '100%'
    },

    label: {
        borderBottom: '1px solid black'
    },

    btnBox: {
        padding: '1em 0em',
        display: 'flex',
        justifyContent: 'flex-start'
    }
});

const SelectInputTypeEnabled = ({
    inputType,
    onContinueClick,
    onTypeChange
}) => {

    return (
        <Stack verticalFill className={classNames.root}>
            <Stack.Item>
                <h3 className={classNames.label}>Vyberte způsob zadání úseků mezí</h3>
            </Stack.Item>
            <Stack.Item>
                <ChoiceGroup
                    selectedKey={inputType}
                    options={[
                        { key: INPUT_TYPE_FILE, text: 'Načíst úseky mezí ze souboru' },
                        { key: INPUT_TYPE_DRAW, text: 'Nakreslit úseky mezí v mapě' }
                    ]}
                    onChange={onTypeChange}
                />
            </Stack.Item>
            <Stack.Item className={classNames.btnBox}>
                <DefaultButton
                    iconProps={{ iconName: 'ChevronRightMed' }}
                    disabled={isNil(inputType)}
                    onClick={onContinueClick}
                    text="Pokračovat"
                />
            </Stack.Item>
        </Stack>
    );
}

export default SelectInputTypeEnabled;
